var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "header"
  }, [_vm.alias ? _c('h2', [_vm._v(_vm._s(_vm.alias))]) : _c('h2', [_vm._v(_vm._s(_vm.addressID))])]), _c('Metadata', {
    attrs: {
      "meta-data": _vm.metaData,
      "address-i-d": _vm.addressID,
      "alias": _vm.alias,
      "total-transaction-count": _vm.totalTransactionCount,
      "total-utxo-count": _vm.totalUtxoCount,
      "assets": _vm.assets,
      "prefix": _vm.prefix
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }